import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api, fmtDT } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader } from "@/components/common";

export default function Notifications() {
  const { t } = useApp();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const open = async (n) => {
    await api.post(`/notifications/${n.id}/read`);
    if (n.link) nav(n.link);
    else load();
  };
  return (
    <div>
      <PageHeader title={t("Notifications")} subtitle="Alerts link to the related patient record. No patient details are sent outside the application."
        actions={<button className="btn btn-ghost" onClick={() => api.post("/notifications/read-all").then(load)} data-testid="mark-all-read-btn"><CheckCheck size={15} />{t("Mark all read")}</button>} />
      <div className="panel divide-y" data-testid="notifications-list">
        {items.map((n) => (
          <button key={n.id} onClick={() => open(n)} data-testid={`notification-${n.id}`}
            className={`flex w-full items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-[var(--surface)] ${n.read ? "opacity-60" : ""}`}>
            <Bell size={15} className={`mt-0.5 ${n.read ? "text-[var(--muted-ink)]" : "text-[#283F91]"}`} />
            <div className="flex-1">
              <div className="text-sm font-medium text-[var(--ink)]">{n.message}</div>
              <div className="mt-0.5 text-[11px] uppercase tracking-wide text-[var(--muted-ink)]">{n.type.replace(/_/g, " ")} · {fmtDT(n.created_at)}</div>
            </div>
            {!n.read && <span className="mt-1 h-2 w-2 rounded-full bg-[#283F91]" />}
          </button>
        ))}
        {!items.length && <div className="p-10 text-center text-sm text-[var(--muted-ink)]">No notifications</div>}
      </div>
    </div>
  );
}
